﻿import { LiveDataSet } from "../../API/LiveData/LiveDataSet";
import { getForecastPDFs, StationFile } from "../../API/StationFiles/StationFiles";
import { IHashData } from "../../IHashData";
import { ILiveDataListener } from "../../ILiveDataListener";
import { IPage } from "../../IPage";
import { MainSite } from "../../MainSite";

export class ForecastsPDFs implements IPage, ILiveDataListener {
    constructor(private mainSite: MainSite) {
    }

    public id: string = 'forecastsPDFs';

    private navBarLink: JQuery;

    public initialize(): void {
        /*if (this.mainSite.currentUser.Region !== "Australia"
            && !this.mainSite.currentUser.Permissions.Administrator
            && !this.mainSite.currentUser.Permissions.GlobalAdministrator
            && branding.siteName !== "METNET SCiN") {
            return;
        }*/

        this.mainSite.liveDataManager.addListener(this);

        this.navBarLink = $('<li></li>').appendTo(this.mainSite.navBar.navLinksLeft);

        $('<a></a>')
            .attr('href', '#')
            .click(() => {
                this.mainSite.changePage(this.id);
                return false;
            })
            .text('Forecasts')
            .appendTo(this.navBarLink);
    }

    private $container: JQuery = null;
    private $colLeft: JQuery;
    private $colRight: JQuery;
    private activeRegionId: string = null;
    // Incremented on each render/teardown so stale async callbacks can be ignored.
    private renderToken: number = 0;

    public handleHashChange(hashData: IHashData): boolean {
        // Keep region strictly hash-driven for page-state consistency.
        this.activeRegionId = hashData.Region;

        if (hashData.Page === this.id) {
            if (this.navBarLink) {
                this.navBarLink.addClass('active');
            }
            if (!this.$container) {
                this.$container = $('<div class="page-container container-fluid"></div>').appendTo('body');
            }
            else {
                // Remove previous handler before rerender to avoid stacked listeners.
                $(window).off(`resize.${this.id}`);
                this.$container.empty();
            }
            this.renderPage();
            return true;
        } else {
            if (this.navBarLink) {
                this.navBarLink.removeClass('active');
            }
            if (this.$container) {
                // Invalidate any in-flight async list fetches for this page instance.
                this.renderToken++;
                $(window).off(`resize.${this.id}`);
                this.$container.remove();
                this.$container = null;
            }
            return false;
        }
    }

    public liveDataChanged(latestData: LiveDataSet): void {
        // this.updateTable();
    }

    private adjustSizes(): void {
        if (this.$colRight.length == 1 && this.$colRight.is(':visible')) {
            let height: number = $(window).height() - this.$colRight.offset().top - 10;
            // this.$colLeft.height(height);
            this.$colRight.height(height);
        }
    }

    private renderPage(): void {
        // Snapshot current render generation; callbacks must match to update UI.
        const token: number = ++this.renderToken;

        let $row: JQuery = $('<div class="row"></div>').appendTo(this.$container);
        this.$colLeft = $('<div class="col-md-4 col-lg-3 no-select"></div>').appendTo($row);
        this.$colRight = $('<div class="col-md-8 col-lg-9 hidden-sm"><em class="text-muted">Loading...</em></div>').appendTo($row);

        this.adjustSizes();
        // Keep exactly one resize handler bound for this page.
        $(window).off(`resize.${this.id}`).on(`resize.${this.id}`, (e) => {
            this.adjustSizes();
        });

        let $list: JQuery = $('<div>').appendTo(this.$colLeft);
        this.renderList($list, token);
    }

    private renderList($target: JQuery, token: number): void {
        $target.empty();

        // Snapshot region once so async callback does not read mutable state.
        const selectedRegionId: string = this.activeRegionId;

        $target.append(`<div class="alert alert-info"><i class="fa fa-lg fa-refresh"></i> Retrieving list of Forecasts...</div>`);
        let $ul: JQuery;

        getForecastPDFs((err, list) => {
            // Ignore responses from older renders or after page teardown.
            if (token !== this.renderToken || !this.$container) {
                return;
            }

            if (err) {
                $target.empty();
                $target.append(`<div class="alert alert-danger">Error while retrieving the list of forecasts from the server: ${err}</div>`);
            } else {
                const filteredSpecial: StationFile[] = this.filterFilesBySelectedRegion(list.Special, selectedRegionId);
                const filteredRegular: StationFile[] = this.filterFilesBySelectedRegion(list.Regular, selectedRegionId);

                $target.empty();

                $(`<h4 style="margin-top: 0;">Special Forecasts</h4>`).appendTo($target);

                if (filteredSpecial.length == 0) {
                    $target.append(`<div class="alert alert-info">No Forecasts available.</div>`);
                } else {
                    $ul = this.renderListWrap().appendTo($target);
                    filteredSpecial.forEach(file => this.renderListItem($ul, file));
                }

                $(`<h4>Other Forecasts</h4>`).appendTo($target);

                if (filteredRegular.length == 0) {
                    $target.append(`<div class="alert alert-info">No Forecasts available.</div>`);
                } else {
                    $ul = this.renderListWrap().appendTo($target);
                    filteredRegular.forEach(file => this.renderListItem($ul, file));
                }

                this.$colRight.html(`<em class="text-muted">Click on an item on the left to load a Forecast PDF.</em>`);
                $target.find('a.list-group-item').eq(0).trigger('click');
            }
        });
    }

    private filterFilesBySelectedRegion(files: StationFile[], selectedRegionId: string): StationFile[] {
        // Intentionally return no files when region is missing/invalid.
        if (!selectedRegionId) {
            return [];
        }

        const regionKey: string = selectedRegionId.toLowerCase();
        return files.filter(file => {
            const stationRegion: string = this.mainSite.staticDataManager.Schema?.ParameterSchema?.Stations[file.StationId]?.Station?.Region;

            // Exclude files that cannot be mapped to a known station region.
            if (!stationRegion) {
                return false;
            }

            return stationRegion.toLowerCase() === regionKey;
        });
    }

    private renderListWrap(): JQuery {
        return $('<ul class="list-group"></ul>');
    }

    private renderListItem($target: JQuery, file: StationFile): void {
        let $link: JQuery = $('<a class="list-group-item branded"></a>').attr('href', file.Link).on('click', (e) => {
            e.preventDefault();
            $target.closest('.page-container').find('.list-group-item.active').removeClass('active');
            $link.addClass('active');

            this.$colRight.empty();
            this.$colRight.html(`<iframe src="${file.Link}" style="border:0; height: 100%; width: 100%; background-color: #eee;">Loading...</iframe>`);
        });

        $(`<span>${file.Name}</span>`).appendTo($link);
        $(`<br>`).appendTo($link);
        let lm: string = "";
        try {
            let m: moment.Moment = moment(file.LastModified);
            lm = this.mainSite.getDisplayTime(file.LastModified, this.mainSite.staticDataManager.Schema?.ParameterSchema?.Stations[file.StationId]?.Station?.TimeZone ?? "UTC");
        } catch (err) {
            lm = "Unable to parse Last Modified.";
        }
        $(`<span class="op-70">${lm}</span>`).appendTo($link);

        $link.appendTo($target);
    }
}